import React from 'react';
import Select, { components as SelectComponents } from 'react-select';
import { connect } from 'react-redux';
// TODO: props
// import PropTypes from 'prop-types';
import ChevronIcon from '@lt/components/icons-react/rebrand/ChevronDown';
import { i18n } from '@lt/localization';
import { getCitizenships } from '../../../routes/Checkout/store/selectors/data';
import { px2rem } from '../../../utils/commonUtils';

import TouristField from '../TouristField';
import withMobile from '../../../routes/Checkout/CheckoutRoutes/PackageCheckout/hocs/withMobile';

class TouristCitizenship extends React.PureComponent {
  static SELECT_STYLE = {
    placeholder: (base) => ({ ...base, fontSize: 12 }),
    control: () => ({
      display: 'flex',
      padding: 12,
      border: '1px solid var(--grey3)',
      borderRadius: 'var(--border-radius)',
    }),
    input: () => ({ overflow: 'hidden', width: 0 }),
    menu: (base) => ({
      ...base,
      width: '220px',
      marginTop: '1rem',
      marginLeft: '-.5rem',
    }),
    option: (base) => ({
      ...base,
      whiteSpace: 'nowrap',
      fontSize: 15,
      overflowX: 'hidden',
    }),
    singleValue: () => ({
      fontWeight: 500,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: px2rem(14),
    }),
    valueContainer: () => ({
      display: 'flex',
      alignItems: 'center',
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base) => ({ ...base, padding: 0 }),
  };

  static SELECT_STYLE_MOBILE = {
    ...TouristCitizenship.SELECT_STYLE,
    menu: (base) => ({
      ...base,
      width: '100%',
      marginTop: '1rem',
      zIndex: 5,
    }),
    control: () => ({
      display: 'flex',
      padding: 12,
      border: '1px solid var(--grey3)',
      borderRadius: 'var(--border-radius)',
    }),
    singleValue: () => ({
      fontWeight: 500,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: px2rem(14),
    }),
    option: (base) => ({
      ...base,
      fontSize: 15,
      overflowX: 'hidden',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: 0,
      // у нас у больших форм для имён так высчитывается длина (только там не 121 пиксель, а 32)
      // и растянуть эту форму на большую длину как в макте получается только через
      // margin у иконки селекта
      marginLeft: 'calc(100vw - 121px)',
    }),
  };

  static SELECT_THEME = (base) => ({
    ...base,
    borderRadius: 8,
    colors: {
      ...base.colors,
      primary: 'var(--secondary)',
      primary25: 'var(--lightorange)',
      primary50: 'var(--lightorange)',
      primary75: 'var(--lightorange)',
    },
  });

  static DropdownIndicator = (props) => (
    <SelectComponents.DropdownIndicator {...props}>
      <ChevronIcon height={14} />
    </SelectComponents.DropdownIndicator>
  );

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const { value } = event;
    const { onChange } = this.props;
    onChange(value);
  }

  get selectedOption() {
    const { value, citizenships } = this.props;
    const selected = citizenships.find((option) => option.value === value);
    return selected;
  }

  render() {
    const { citizenships, className, isMobile, ...others } = this.props;
    const styles = isMobile
      ? TouristCitizenship.SELECT_STYLE_MOBILE
      : TouristCitizenship.SELECT_STYLE;
    return (
      <TouristField
        {...others}
        className={className}
        label={i18n.t('checkout.touristForm.citizenship')}
        items={citizenships}
      >
        <Select
          classNamePrefix="citizenship-select"
          styles={styles}
          theme={TouristCitizenship.SELECT_THEME}
          value={this.selectedOption}
          options={citizenships}
          onChange={this.handleChange}
          placeholder={i18n.t('checkout.touristForm.select')}
          noOptionsMessage={() => null}
          components={{
            DropdownIndicator: TouristCitizenship.DropdownIndicator,
          }}
        />
      </TouristField>
    );
  }
}

TouristCitizenship.propTypes = {};

const mapStateToProps = (state) => ({
  citizenships: getCitizenships(state),
});

export default connect(mapStateToProps)(withMobile(TouristCitizenship));
